(function () {
  "use strict";

  a3_cabin_reports.controller("CrewExpiriesCtrl", CrewExpiriesCtrl);

  /**
   * @ngInject
   */
  function CrewExpiriesCtrl($scope, ExpiriesFactory, AirlineInfoFactory, UserFactory) {
    $scope.user = UserFactory.getUser();
    $scope.exportInProgress = false;

    // ----------------------------
    // View model 
    // ----------------------------
    $scope.vm = {
      selectedAirline: null,
      selectedFleetId: null,
      selectedAirlineInfos: [],
    };

    // ----------------------------
    // Expiries
    // ----------------------------
    $scope.allExpiries = [];

    ExpiriesFactory.getAllExpiriesFromStorage().then(function (allExpiries) {
      $scope.allExpiries = (allExpiries || []).sort(function (a, b) {
        var da = a && a.ExpiryDate ? new Date(a.ExpiryDate).getTime() : Number.POSITIVE_INFINITY;
        var db = b && b.ExpiryDate ? new Date(b.ExpiryDate).getTime() : Number.POSITIVE_INFINITY;
        return da - db;
      });
    });

    $scope.getHighlight = function (expiryDate) {
      if (!expiryDate) return;

      var today = new Date();
      var expDate = new Date(expiryDate);
      if (isNaN(expDate.getTime())) return;

      var diffDays = Math.ceil((expDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
      if (diffDays < 30) return "#D43F3A";
      if (diffDays < 90) return "#FFaB5E";
    };

    // ----------------------------
    // Airline data (from storage)
    // ----------------------------
    $scope.crewAirlineInfos = AirlineInfoFactory.getCrewAirlineInfos() || [];
    $scope.crewAirlineOptions = AirlineInfoFactory.getCrewAirlineOptions() || [];

    // ----------------------------
    // Helpers
    // ----------------------------
    function norm(s) {
      return (s || "").toString().trim().toLowerCase();
    }

    $scope.cleanDisplayValue = function (value) {
      return (value || "").toString().replace(/[\s,]+$/, "").trim();
    };

    function findAirlineByFleetId(fleetId) {
      var list = $scope.crewAirlineOptions || [];
      var id = Number(fleetId);
      if (isNaN(id)) return null;

      for (var i = 0; i < list.length; i++) {
        if (Number(list[i].FleetId) === id) return list[i];
      }
      return null;
    }

    function recomputeSelectedInfos() {
      var infos = $scope.crewAirlineInfos || [];
      var sel = $scope.vm.selectedAirline;

      if (!sel) {
        $scope.vm.selectedAirlineInfos = infos;
        return;
      }

      var hasFleetOnInfo = infos.some(function (x) {
        return x && x.FleetId != null;
      });

      // Prefer exact FleetId match when possible
      if (hasFleetOnInfo && sel.FleetId != null) {
        $scope.vm.selectedAirlineInfos = infos.filter(function (x) {
          return Number(x.FleetId) === Number(sel.FleetId);
        });
        return;
      }

      // Fallback: keyword match on CompanyName
      var airline = norm(sel.Airline);

      $scope.vm.selectedAirlineInfos = infos.filter(function (x) {
        return norm(x.CompanyName).indexOf(airline) >= 0;
      });
    }

    function applySelectionByAirline(airlineObj) {
      if (!airlineObj) {
        $scope.vm.selectedAirline = null;
        $scope.vm.selectedFleetId = null;
        $scope.vm.selectedAirlineInfos = [];
        return;
      }

      $scope.vm.selectedAirline = airlineObj;
      $scope.vm.selectedFleetId = Number(airlineObj.FleetId);
      recomputeSelectedInfos();
    }

    // ----------------------------
    // INIT
    // ----------------------------
    (function init() {
      var options = $scope.crewAirlineOptions || [];
      if (!options.length) {
        applySelectionByAirline(null);
        return;
      }

      var defaultFleetId = AirlineInfoFactory.getDefaultFleetId
        ? AirlineInfoFactory.getDefaultFleetId()
        : null;

      var selected = defaultFleetId != null
        ? findAirlineByFleetId(defaultFleetId)
        : null;

      if (!selected) selected = options[0];

      applySelectionByAirline(selected);
    })();

    // ----------------------------
    // User actions
    // ----------------------------
    $scope.switchAirline = function () {
      var options = $scope.crewAirlineOptions || [];
      if (options.length < 2) return;

      var current = $scope.vm.selectedAirline;

      // Guard: if selection is missing, pick first
      if (!current || current.FleetId == null) {
        applySelectionByAirline(options[0]);
        return;
      }

      var index = options.findIndex(function (x) {
        return Number(x.FleetId) === Number(current.FleetId);
      });

      if (index < 0) index = 0;

      var nextIndex = (index + 1) % options.length;
      applySelectionByAirline(options[nextIndex]);
    };

    $scope.getAirlineLogoUrl = function () {
      if (!$scope.vm.selectedAirline) return null;

      var airline = norm($scope.vm.selectedAirline.Airline);

      if (airline === "aegean") return "img/a3_logo.png";
      if (airline === "olympic") return "img/Logo_OA.png";

      return "img/a3_logo.png";
    };

    function formatDate(value) {
      if (!value) return null;
      var d = new Date(value);
      if (isNaN(d.getTime())) return null;
      return d.toString("yyyy/MM/dd");
    }

    function getLicenseNumbers(infos) {
      var map = {};
      var result = [];
      (infos || []).forEach(function (info) {
        var values = [info && info.LicenseNo, info && info.SecondaryLicenseNo];
        values.forEach(function (value) {
          var key = (value || "").toString().trim();
          if (!key || map[key]) return;
          map[key] = true;
          result.push(key);
        });
      });
      return result.join(", ");
    }

    function buildExportPayload() {
      var selectedInfos = $scope.vm.selectedAirlineInfos || [];
      var licenseNumbers = getLicenseNumbers(selectedInfos);
      var primaryInfo = selectedInfos.length ? selectedInfos[0] : null;
      var airline = $scope.vm.selectedAirline || null;
      var crewMemberAimsId = $scope.user && $scope.user.aimsId
        ? Number($scope.user.aimsId)
        : null;

      return {
        Rows: ($scope.allExpiries || []).map(function (x) {
          return {
            CrewMemberAimsId: crewMemberAimsId,
            CrewMemberName: $scope.user && $scope.user.name ? $scope.user.name : null,
            Airline: airline ? airline.Airline : null,
            AirlineCode: airline && airline.Airline ? norm(airline.Airline) : null,
            FleetId: airline ? airline.FleetId : null,
            CompanyName: primaryInfo && primaryInfo.CompanyName ? primaryInfo.CompanyName : null,
            AOC: primaryInfo && primaryInfo.AOC ? primaryInfo.AOC : null,
            Address: primaryInfo && primaryInfo.Address ? primaryInfo.Address : null,
            LicenseNo: primaryInfo && primaryInfo.LicenseNo ? primaryInfo.LicenseNo : null,
            SecondaryLicenseNo: primaryInfo && primaryInfo.SecondaryLicenseNo ? primaryInfo.SecondaryLicenseNo : null,
            LicenseNumbers: licenseNumbers,
            Code: x && x.ExpiryType ? x.ExpiryType.toString().trim() : null,
            ExpiryType: x && x.ExpiryType ? x.ExpiryType.toString().trim() : null,
            ExpiryTypeId: x && x.ExpiryTypeId != null ? x.ExpiryTypeId : null,
            Description: x && x.Description ? x.Description : null,
            LastDone: formatDate(x && x.LastCkecked),
            ExpiryDate: formatDate(x && x.ExpiryDate),
            NextPlanned: formatDate(x && (x.NextPlanned || x.NextPlannedDate)),
          };
        }),
      };
    }

    $scope.exportToPdf = function () {
      if ($scope.exportInProgress) return;

      $scope.exportInProgress = true;
      var payload = buildExportPayload();

      ExpiriesFactory.exportCrewExpiriesToPdf(payload)
        .then(function (response) {
          var disposition =
            response &&
            response.headers &&
            response.headers("content-disposition");
          var fileName = "CrewExpiries.pdf";

          if (disposition) {
            var match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
            if (match && match[1]) {
              fileName = decodeURIComponent(match[1]);
            }
          }

          var blob = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
            return;
          }

          var url = window.URL.createObjectURL(blob);
          var link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(function () {
          bootbox.alert("Failed to export Crew Expiries PDF.");
        })
        .finally(function () {
          $scope.exportInProgress = false;
        });
    };
  }
})();
